import { makeStyles } from "@material-ui/core/styles";

export const blumiraAgentActivationBannerStyles = makeStyles((theme) => ({
  activationBannerContainer: {
    "& a": {
      fontWeight: "bold",
      color: theme.palette.primary.main,
      "& :hover": {
        color: theme.palette.primary.main,
      },
    },
  },
  alertTitle: {
    fontWeight: "bold",
  },
  leftMarginLink: {
    marginLeft: 10,
  },
  linkContainer: {
    display: "flex",
    alignItems: "center",
    paddingTop: theme.shape.padding,
  },
  activateButton: {
    width: 250,
    marginRight: theme.shape.padding,
  },
}));
